function showEmptyListMessage() {
  $('.list-items__empty').addClass('list-items__empty--active');
  $('.list-items__wrapper').removeClass('list-items__wrapper--active');
}

function hideEmptyListMessage() {
  $('.list-items__empty').removeClass('list-items__empty--active');
  $('.list-items__wrapper').addClass('list-items__wrapper--active');
}

function checkEmptyListMessage() {
  if (!$('.list-item__row--body').length) {
    showEmptyListMessage();
  } else {
    hideEmptyListMessage();
  }
}
